// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vi0FJ","col":"styles_col__fW0rj"};